import { Box, Button, Stack, Typography, useMediaQuery } from '@mui/material'
import { useSyncExternalStore } from 'react'
import { MOBILE_NAV_HEIGHT, PWA_NAV_SAFE_BOTTOM } from '../../consts/mobileLayout'
import { useIsPwa } from '../../hooks/useIsPwa'
import {
  applyAppUpdate,
  getAppUpdateState,
  subscribeAppUpdate,
} from '../../serviceWorker/serviceWorkerUpdateCoordinator'
import { PureLightTheme } from '../../styles/theme'
import { COLORS } from '../../styles/variables'

const APP_HEADER_HEIGHT_PX = 60
const BANNER_NAV_GAP_PX = 8

export function AppUpdateBanner() {
  const state = useSyncExternalStore(subscribeAppUpdate, getAppUpdateState, getAppUpdateState)
  const isMobile = useMediaQuery(PureLightTheme.breakpoints.down('md'))
  const isPwa = useIsPwa()

  if (state !== 'update-ready' && state !== 'applying') {
    return null
  }

  const isApplying = state === 'applying'
  const mobileBottomOffset = isPwa
    ? `calc(${MOBILE_NAV_HEIGHT} + ${PWA_NAV_SAFE_BOTTOM} + ${BANNER_NAV_GAP_PX}px)`
    : `calc(${MOBILE_NAV_HEIGHT} + ${BANNER_NAV_GAP_PX}px)`

  const bannerSx = {
    position: 'fixed',
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 1300,
    maxWidth: 'min(560px, calc(100vw - 32px))',
    width: { xs: 'calc(100vw - 32px)', sm: 'max-content' },
    px: 2,
    py: 1.25,
    borderRadius: 2,
    bgcolor: COLORS.CERULEAN,
    boxShadow: '0 6px 20px rgba(10, 158, 222, 0.35)',
    top: isMobile ? 'auto' : `calc(${APP_HEADER_HEIGHT_PX}px + env(safe-area-inset-top, 0px) + 8px)`,
    bottom: isMobile ? mobileBottomOffset : 'auto',
  }

  return (
    <Box sx={bannerSx} role="status" aria-live="polite">
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'center', sm: 'center' }}
        gap={1.5}
      >
        <Typography
          variant="body2"
          sx={{
            color: COLORS.WHITE,
            fontWeight: 600,
            whiteSpace: { sm: 'nowrap' },
            textAlign: { xs: 'center', sm: 'left' },
          }}
        >
          Доступна новая версия приложения
        </Typography>
        <Button
          variant="follow"
          size="small"
          disabled={isApplying}
          onClick={() => applyAppUpdate()}
          sx={{
            flexShrink: 0,
            alignSelf: { xs: 'stretch', sm: 'auto' },
            width: { xs: '100%', sm: 'auto' },
            bgcolor: COLORS.WHITE,
            color: COLORS.NICE_BLUE,
            borderColor: COLORS.WHITE,
            fontWeight: 600,
            '&:hover': {
              bgcolor: COLORS.CATSKILL_WHITE,
              borderColor: COLORS.CATSKILL_WHITE,
            },
            '&.Mui-disabled': {
              bgcolor: COLORS.CATSKILL_WHITE,
              color: COLORS.NICE_BLUE,
              opacity: 0.8,
            },
          }}
        >
          {isApplying ? 'Загрузка…' : 'Загрузить новую версию'}
        </Button>
      </Stack>
    </Box>
  )
}
